module.exports = __webpack_public_path__ + "static/media/16UNODC19.558e8a40.jpg";